import {
    SET_FINAL_FORM_UNSAVED_VALUES,
    REMOVE_FINAL_FORM_UNSAVED_VALUES
} from './constants';

export function setFinalFormUnsavedValues(namespace, finalFormUnsavedValues) {
    return {
        type: SET_FINAL_FORM_UNSAVED_VALUES,
        payload: {
            namespace,
            finalFormUnsavedValues
        }
    };
}

export function removeFinalFormUnsavedValues(namespace) {
    return {
        type: REMOVE_FINAL_FORM_UNSAVED_VALUES,
        payload: {
            namespace
        }
    };
}
